import { createRouter, createWebHistory } from "vue-router";
import { useToast } from "vue-toastification";

// Страницы
import PageNotFound from "@/pages/PageNotFound.vue";
import Home from "@/pages/Home.vue";
import ProductList from "@/pages/ProductList.vue";
import Profile from "@/pages/Profile.vue";
import ProductPage from "@/pages/ProductPage.vue";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage.vue";
import PaymentFaliPage from "@/pages/PaymentFaliPage.vue";
import TextPage from "@/pages/TextPage.vue";
import Contacts from "@/pages/Contacts.vue";
import EmailAlreadyVerified from "@/pages/EmailAlreadyVerified.vue";
import EmailVerificationNotice from "@/pages/EmailVerificationNotice.vue";
import EmailVerificationSuccess from "@/pages/EmailVerificationSuccess.vue";
import PaymentPendingPage from "@/pages/PaymentPendingPage.vue";
import CoinBundlePage from "@/pages/CoinBundlePage.vue";
import ResetPassword from "@/pages/ResetPassword.vue";

const routes = [
  { path: "/", redirect: "/home" },
  { path: "/home", name: "Home", component: Home },
  { path: "/product-list", name: "ProductList", component: ProductList },
  {
    path: "/profile/:page",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/products/:type/:id",
    name: "ProductPage",
    component: ProductPage,
    props: true,
  },
  { path: "/coin-bundles/:slug", name: "CoinBundlePage", component: CoinBundlePage },
  { path: "/success-payment", name: "PaymentSuccessPage", component: PaymentSuccessPage },
  { path: "/fail-payment", name: "PaymentFaliPage", component: PaymentFaliPage },
  { path: "/processing-payment", name: "PaymentPendingPage", component: PaymentPendingPage },
  { path: "/contacts", name: "Contacts", component: Contacts },
  { path: "/pages/:id", name: "TextPage", component: TextPage },
  {
    path: "/email/verify/already-success",
    name: "EmailAlreadyVerified",
    component: EmailAlreadyVerified,
  },
  {
    path: "/email/verify/success",
    name: "EmailVerificationSuccess",
    component: EmailVerificationSuccess,
  },
  {
    path: "/email/verify/notice",
    name: "EmailVerificationNotice",
    component: EmailVerificationNotice,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    props: true,
  },
  {
    path: "/:pathMatch(.*)*", // 404 route
    name: "PageNotFound",
    component: PageNotFound,
    props: { title: "PageNotFound" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Toast доступен только внутри компонента или после инициализации Vue,
// поэтому используем отложенный импорт через useToast внутри guard
router.beforeEach((to, from, next) => {
  const isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated") || "false");
  const emailVerified = JSON.parse(localStorage.getItem("emailVerified") || "false");

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      // Получаем toast при первом переходе, только когда уже есть app context
      const toast = useToast();
      toast.info("Please log in first");
      return next({ name: "Home", query: { redirect: to.fullPath } });
    } else if (!emailVerified) {
      const toast = useToast();
      toast.info("Please verify your email");
      return next({ name: "EmailVerificationNotice", query: { redirect: to.fullPath } });
    }
  }

  return next();
});

export default router;
